// The WebGL renderer and its canvas.
import * as THREE from 'three';

// ---------- renderer / scene ----------
export const renderer = new THREE.WebGLRenderer({ antialias: true });
// phones: native-ish resolution is too heavy for the paint filter; 1x keeps it smooth
renderer.setPixelRatio(
  Math.min(devicePixelRatio, matchMedia('(pointer: coarse)').matches ? 1 : 1.5),
);
renderer.setSize(innerWidth, innerHeight);
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
document.body.appendChild(renderer.domElement);
